module.exports = __webpack_public_path__ + "static/media/ai_discovery.3c23bed4.svg";